module.exports = __webpack_public_path__ + "img/bal.60d37457.svg";